import React from "react";

import { Icons } from "components";

import * as S from "./styles";

export type BreadcrumbProps = {
  steps: Array<{
    icon: string;
    title: string;
    done?: boolean;
    onClick: () => void;
  }>;
  current: number;
};

export const Breadcrumb = (props: BreadcrumbProps) => {
  return (
    <S.Container>
      <S.List>
        {props.steps.map((step, index) => {
          const current = props.current + 1 === index + 1;

          return (
            <S.Item
              key={index}
              active={current}
              done={step.done}
              onClick={step.onClick}
            >
              <S.Icon>
                <Icons.FeatherIcons name={step.icon as any} />
              </S.Icon>

              {!!current && (
                <S.Detail>
                  <S.Step>
                    Etapa {index + 1}/{props.steps.length}
                  </S.Step>

                  <S.Title>{step.title}</S.Title>
                </S.Detail>
              )}
            </S.Item>
          );
        })}
      </S.List>
    </S.Container>
  );
};
